module.exports = __webpack_public_path__ + "media/facial-recognition/arrow-icon-light-fd0bb740.svg";